/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ExceptionResponseDTO } from '../model/models';
import { GenericResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';
import { ServizioMensaPastiDaPreparareDTO } from '../model/models';
import { ServizioMensaReportMensileDTO } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface CalcolaServizioMensaPastiDaPreparareRequestParams {
    data: string;
    gestioneMenseServizioId: string;
}

export interface GetServizioMensaPastiDaPreparareRequestParams {
    data: string;
    gestioneMenseServizioId: string;
}

export interface GetServizioMensaPastiDaPreparareIntervalloRequestParams {
    dataInizio: string;
    dataFine: string;
    gestioneMenseServizioId: string;
}

export interface GetServizioMensaPastiDaPreparareMensileRequestParams {
    dataInizio: string;
    dataFine: string;
    gestioneMenseServizioId: string;
}


export interface ServizioMensaPastiDaPreparareServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Forza il calcolo dei pasti da preparare di un servizio per una data.
     * Ricalcola e sostituisce (delete+save idempotente) gli snapshot del servizio risolto dall\&#39;header Gestione-Mense-Servizio-Id per la data indicata. Audience backoffice (OP_COMUNE/ADMIN/SUPERADMIN): operazione di scrittura.
     * @endpoint post /api/v1/servizi/mensa/pasti-da-preparare/calcola
* @param requestParameters
     */
    calcolaServizioMensaPastiDaPreparare(requestParameters: CalcolaServizioMensaPastiDaPreparareRequestParams, extraHttpRequestParams?: any): Observable<GenericResponseDTO>;

    /**
     * Report dei pasti da preparare di un giorno.
     * Ritorna i conteggi dello snapshot del servizio per la data (solo conteggi, no costi). Assente → 204 No-Content (parity legacy). Audience servizio piena.
     * @endpoint get /api/v1/servizi/mensa/pasti-da-preparare
* @param requestParameters
     */
    getServizioMensaPastiDaPreparare(requestParameters: GetServizioMensaPastiDaPreparareRequestParams, extraHttpRequestParams?: any): Observable<ServizioMensaPastiDaPreparareDTO>;

    /**
     * Report aggregato dei pasti da preparare su un intervallo.
     * Somma gli snapshot del periodo per scuola/ordinamento + numero minimo pasti da fatturare per scuola (numeroMinimoPastiDaFatturare × giorni di apertura). Solo conteggi. Audience servizio piena.
     * @endpoint get /api/v1/servizi/mensa/pasti-da-preparare/intervallo
* @param requestParameters
     */
    getServizioMensaPastiDaPreparareIntervallo(requestParameters: GetServizioMensaPastiDaPreparareIntervalloRequestParams, extraHttpRequestParams?: any): Observable<ServizioMensaPastiDaPreparareDTO>;

    /**
     * Report mensile dei pasti da preparare.
     * Disaggrega gli snapshot dell\&#39;intervallo per mese (un elemento per mese, ordinati cronologicamente, con label leggibile). Solo conteggi. Audience servizio piena.
     * @endpoint get /api/v1/servizi/mensa/pasti-da-preparare/mensile
* @param requestParameters
     */
    getServizioMensaPastiDaPreparareMensile(requestParameters: GetServizioMensaPastiDaPreparareMensileRequestParams, extraHttpRequestParams?: any): Observable<Array<ServizioMensaReportMensileDTO>>;

}
